import axios from '@/libs/api.request'

// 查询字典类型列表
export function dictTypeList(params) {
  return axios.request({
    url: '/sys/dict/type/list',
    method: 'get',
    params
  })
}

// 查询字典类型详细
export function dictTypeInfo(dictId) {
  return axios.request({
    url: `/sys/dict/type/info/${dictId}`,
    method: 'get'
  })
}

// 新增字典类型
export function addDictType(data) {
  return axios.request({
    url: '/sys/dict/type/save',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 修改字典类型
export function updateDictType(data) {
  return axios.request({
    url: '/sys/dict/type/update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 删除字典类型
export function delDictType(dictIds) {
  return axios.request({
    url: '/sys/dict/type/delete',
    method: 'post',
    data: dictIds,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
